import React from 'react';
import type { StepTest } from 'types/SparkStep';
import SparkTestOutputContainer from '../SparkTestOutputContainer';

type SparkTestsOutputProps = {
  isParentLoading?: boolean;
  sparkTestResults: StepTest | null;
  outputTypeID?: string | null;
  onError: (errorMessage: string) => void;
  outputError: string | null;
};

function SparkTestsOutput({
  isParentLoading = false,
  sparkTestResults,
  outputTypeID,
  onError,
  outputError,
}: SparkTestsOutputProps) {
  return (
    <SparkTestOutputContainer
      isParentLoading={isParentLoading}
      output={sparkTestResults?.SparkTask.Output}
      outputTypeID={outputTypeID}
      onError={onError}
      outputError={outputError}
    />
  );
}

export default SparkTestsOutput;
